/*
 * FRENESI · Benefícios da compra (rendimento + cashback) — comportamento do
 * elemento <frenesi-purchase-benefits> de blocks/frenesi-purchase-benefits.liquid.
 *
 * 15/09/2026: saiu do {% javascript %} do bloco para este asset. Motivo: o JS
 * de bloco só é embutido nas páginas onde o bloco está no template (PDP); o
 * quick-add busca apenas o HTML da seção, então em coleções e na home o
 * elemento nascia inerte e o rendimento não acompanhava o volume escolhido.
 * Carregado por snippets/quick-add-modal.liquid (todas as páginas) e pelo
 * próprio bloco (garantia na PDP). A guarda customElements.get evita definir
 * duas vezes.
 */
if (!customElements.get('frenesi-purchase-benefits')) {
  customElements.define('frenesi-purchase-benefits', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      try {
        this.volumes = JSON.parse(this.querySelector('[data-benefit-volumes]')?.textContent || '{}');
      } catch {
        this.volumes = {};
      }
      const signal = this.controller.signal;
      const onChange = (event) => {
        const scope = this.getScope();
        if (event.target instanceof Element && scope?.contains(event.target) && event.target.closest('variant-picker')) this.updateYield();
      };
      document.addEventListener('change', onChange, { signal });
      document.addEventListener('variant:update', onChange, { signal });
      document.addEventListener('frenesi:spray-yield:update', () => this.updateYield(), { signal });
      this.updateYield();
    }
    disconnectedCallback() { this.controller?.abort(); }
    getScope() {
      return this.closest('quick-add-dialog, .quick-add-modal__content, .product-details, [data-product-grid-content]') || this.parentElement;
    }
    updateYield() {
      const picker = this.getScope()?.querySelector('variant-picker');
      let volume = this.dataset.initialVolume || '';
      if (picker) {
        const controls = [...picker.querySelectorAll('input[type="radio"]:checked, select')];
        if (controls.length) {
          volume = '';
          for (const control of controls) {
            const normalized = String(control.value || '').toLowerCase().replace(/\s+/g, '').replace('ml.', 'ml');
            if (Object.hasOwn(this.volumes, normalized)) { volume = normalized; break; }
          }
        }
      }
      const data = this.dataset.isDecant === 'true' ? this.volumes[volume] : null;
      const row = this.querySelector('[data-benefit-yield]');
      if (!row) return;
      row.hidden = !data;
      this.hidden = !data && this.dataset.hasCashback !== 'true';
      if (!data) return;
      this.dataset.currentVolume = volume;
      for (const [selector, value] of [['[data-benefit-count]', data.count], ['[data-benefit-description]', data.description]]) {
        const element = this.querySelector(selector);
        if (element && element.textContent !== value) element.textContent = value;
      }
    }
  });
}
